import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { setSession } = useAuth();
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: decodeURIComponent(m[1]) });
        setSession(data.token, data.user);
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${data.user.name?.split(" ")[0] || "there"}!`);
        nav(data.user.role === "admin" ? "/admin" : "/dashboard", { replace: true });
      } catch (e) {
        toast.error(apiErr(e, "Google sign-in failed. Please try again."));
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setSession]);

  return (
    <div className="min-h-[calc(100vh-110px)] flex flex-col items-center justify-center gap-4" data-testid="auth-callback">
      <Loader2 className="w-10 h-10 text-brand-red animate-spin" />
      <p className="text-slate-600 font-medium">Signing you in with Google…</p>
    </div>
  );
}
